module.exports = __webpack_public_path__ + "img/bank4.95a29072.png";